import { ShiftManagementShiftConfigurationFragment } from 'generated/resources/graphql'

const DAY_TYPE = Object.freeze({
  shift: 'shift',
  restDay: 'rest_day',
  emptyCell: 'empty_cell',
})

export const isRestDay = (
  shiftConfiguration: ShiftManagementShiftConfigurationFragment
): boolean => {
  return shiftConfiguration.dayType === DAY_TYPE.restDay
}

export const isShift = (shiftConfiguration: ShiftManagementShiftConfigurationFragment): boolean => {
  return shiftConfiguration.dayType === DAY_TYPE.shift
}

export const isEmptyCell = (
  shiftConfiguration: ShiftManagementShiftConfigurationFragment
): boolean => {
  return shiftConfiguration.dayType === DAY_TYPE.emptyCell
}
